import React from 'react';
import { Modal } from 'react-bootstrap';

/** Shown after a contribution is sent: what happens next, and where to follow it. */
const SuccessModal = ({ show, newPolymers = [], runs, onClose, onNavigateToMySubmissions }) => (
    <Modal show={show} onHide={onClose} centered backdrop="static" keyboard={false} aria-labelledby="success-title">
        <Modal.Body className="p-4">
            <div className="d-flex align-items-start gap-3">
                <span className="d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                    style={{ width: 44, height: 44, background: '#ecfdf3', color: '#15803d', fontSize: '1.4rem' }} aria-hidden="true">
                    <i className="bi bi-check2"></i>
                </span>
                <div>
                    <h2 id="success-title" className="h5 fw-bold mb-1" style={{ color: '#0f172a' }}>Submitted for review</h2>
                    <p className="mb-2" style={{ color: '#334155' }}>
                        Thank you! {runs ? `Your ${runs} run${runs === 1 ? ' was' : 's were'}` : 'Your data was'} sent to the moderators.
                        Once approved, {runs === 1 ? 'it becomes' : 'they become'} part of the public dataset with you credited as contributor.
                    </p>
                    <p className="small mb-0" style={{ color: '#64748b' }}>You can follow the review and make changes in My Submissions.</p>
                </div>
            </div>
            {newPolymers.length > 0 && (
                <div className="alert alert-warning small mt-3 mb-0">
                    <i className="bi bi-hourglass-split me-1"></i>
                    You defined {newPolymers.length === 1 ? 'a new polymer' : 'new polymers'}: <strong>{newPolymers.join(', ')}</strong>.
                    An administrator reviews {newPolymers.length === 1 ? 'it' : 'them'} first; the runs using {newPolymers.length === 1 ? 'it' : 'them'} are
                    marked <em>Needs update</em> until then and go to review automatically once approved.
                </div>
            )}
        </Modal.Body>
        <Modal.Footer className="border-top-0 pt-0 px-4 pb-4 gap-2">
            <button type="button" className="btn btn-light fw-semibold" onClick={onClose}>Contribute more</button>
            <button type="button" className="btn fw-semibold text-white" style={{ background: '#0b3d6e' }} onClick={onNavigateToMySubmissions}>
                Go to My Submissions
            </button>
        </Modal.Footer>
    </Modal>
);

export default SuccessModal;
